import type { App } from 'vue'
import { Geetest } from 'vue3-geetest'
export default function useGeetest(app: App) {
  app.use(Geetest, {
    captchaId: '5d880795f1d65adad5b3dc8cafd9e432',
  })
}
